import PhoneInput from 'react-phone-input-2';

const columns = [
  {
    field: 'fullName',
    label: 'Imię Nazwisko',
    sort: 'asc',
    width: 150
  },
  {
    field: 'phoneNumber',
    label: 'Telefon',
    sort: 'asc',
    width: 150,
    type: 'custom',
    custom: function(column, row, navigate) {
      return <PhoneInput
        value={row.phoneNumber}
        country={'pl'}
        disabled
        inputProps={{ readOnly: true }}
        containerStyle={{ pointerEvents: 'none' }}
        inputStyle={{
          border: 'none',
          backgroundColor: 'transparent',
          paddingLeft: '50px', // by ikona flagi się zmieściła
          height: '32px'
        }}
      />;
    }

  },
  {
    field: 'email',
    label: 'Email',
    sort: 'asc',
    width: 200,
    type: 'badge',
    badgeColor: 'neutral-700'
  }
];

export default columns;
